import React,{useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LoginPage } from './componen/LoginPage';
import { alamatAplikasi, alamatUtama } from './utils/domain';
import { tungguLogout } from './utils/tungguLogout';
import { DashboardPages } from './pages/DashboardPages';
import { UserListPages } from './pages/UserListPages';
import { ProfilePages } from './pages/ProfilePages';
import { TransactionPages } from './pages/TransactionPages';
import { ProductPages } from './pages/ProductPages';
import { CategoryPages } from './pages/CategoryPages';
import { ProfileKasirPages } from './pages/ProfileKasirPages';
import { TransaksiKasirPages } from './pages/TransaksiKasirPages';
import { BranchPages } from './pages/BranchPages';
import { PrivateRoute } from './PrivateRoute';
import { InvoicePages } from './pages/InvoicePages';
import { ProdukPerCabangPages } from './pages/ProductPerCabangPages';//view transaksi kasir
import { WarehousePages } from './pages/WarehousePages';
import { StockCabangPages } from './pages/StockCabangPages';
import { StockAllBranchPages } from './pages/StockAllBrancPages';
import { KomprehensifPages } from './pages/invoicePages/KomprehensifPages';
import { PenjualanPerkategoriPages } from './pages/invoicePages/PenjualanPerkategoriPages';
import { StockPerCabangPages } from './pages/invoicePages/StockPerCabangPages';
import { CreateJurnalPages } from './pages/jurnalPages/CreateJurnalPages';
import { GetJurnalPages } from './pages/jurnalPages/GetJurnalPages';
import { KonfigurasiPages } from './pages/konfigurasiPages';
import { StrukPages } from './pages/StrukPages';
import { UlasanGoogleHalamanPages } from './pages/UlasanGoogleHalamanPages';
import { ReservasiPages } from './pages/ReservasiPages';
import ReservasiKasir from './componen/kasir/ReservasiKasir';
import { HomepageSettingsPages } from './pages/homepageSettingsPages';
import { PaketFiturPages } from './pages/PaketFiturPages';
import { LaporanShiftPages } from './pages/LaporanShiftPages';
import { LogAktivitasPages } from './pages/LogAktivitasPages';
import CatatAkses from './componen/log/CatatAkses';
import { StokOpnamePages } from './pages/StokOpnamePages';
import { PengaturanAbsensiPages } from './pages/PengaturanAbsensiPages';
import { BahanBakuPages } from './pages/BahanBakuPages';
import { PembelianPages } from './pages/PembelianPages';
import { RiwayatRefundPages } from './pages/RiwayatRefundPages';
import { CetakLabelPages } from './pages/CetakLabelPages';
import { PiutangPages, LaporanPiutangPages, PiutangKasirPages, PiutangRetailPages } from './pages/PiutangPages';
import { PromoPages } from './pages/PromoPages';
import { IntegrasiPages } from './pages/IntegrasiPages';
import LanggananNotice from './componen/langganan/LanggananNotice';
//import Product from './componen/kasir/transaksi/Produc';
import { MutasiPages } from './pages/MutasiPages';
import { TableDataPages } from './pages/table/TableDataPages';
import { Me } from './fitur/AuthSlice';
import NotificationLayout from './layouts/NotificationLayout';
import DetailsLayout from './layouts/DetailsLayout';
import OrderStatusPage from './componen/OrderStatusPage';
import Notification from './componen/kasir/Notification';
import OrderDetails from './componen/kasir/OrderDetails';
import AntrianKasir from './componen/kasir/AntrianKasir';
    
import { CustomerPages } from './pages/CustomerPages';
import { CustomerTransaksiPages } from './pages/CustomerTransaksiPages';
import { CustomerCategoriPages } from './pages/CustomerCategoriPages';
import LayoutTablePages from './pages/LayoutTablePages';
import LayoutMejaKasir from './layouts/LayoutMejaKasir';
//dashboard karyawan presensi dan admin
import { DashboardPresensiPages } from './pages/presensiPages/DashboardPresensiPages';
import { DashboardKaryawanPages } from './pages/presensiPages/DashboardKaryawanPages';
import CreateAbsen from './componen/presensi/clockIn';
import ClockOut from './componen/presensi/clockOut';
import AbsensiPage from './componen/presensi/getAbsensi';
import Kehadiranbulan from './componen/presensi/Kehadiranbulan';
import ProfileKaryawan from './componen/presensi/ProfileKaryawan';
import { FormEditProfile } from './componen/presensi/FormEditProfile';
import { DataPresensiPages } from './pages/presensiPages/DataPresensiPages';
import { DataPresensiBulanPages } from './pages/presensiPages/DataPresensiBulanPages';
import { AbsenManualPages } from './pages/presensiPages/AbsenManualPages';
import { LokasiPresensiPages } from './pages/presensiPages/LokasiPresensiPages';
import { RekapPresensiPages } from './pages/presensiPages/RekapPresensiPages';
import DapurPages from './pages/DapurPages';
import { MengelolaGajiKaryawanPages } from './pages/gajiKaryawanPages/MengelolaGajiKaryawanPages';
import { CreateGajiKaryawanPages } from './pages/gajiKaryawanPages/CreateGajiKaryawanPages';
import { DataGajiKaryawanPages } from './pages/gajiKaryawanPages/DataGajiKaryawanPages';
import { ConfirmGajiKaryawanPages } from './pages/gajiKaryawanPages/ConfirmGajiKaryawanPages';
import { SerialNumberPages } from './pages/SerialNumberPages';
import { SerialNumberReportPages } from './pages/SerialNumberReportPages';
import LayoutRetail from './componen/kasir/retail/LayoutRetail';
import CartRetail from './componen/kasir/retail/CartRetail';
import TransaksiRetail from './componen/kasir/retail/TransaksiRetail';
import OrderDetailRetail from './componen/kasir/retail/OrderDetailRetail';
import ProfileRetail from './componen/kasir/retail/ProfileRetail';
import LandingPage from './Landing'
import { TakeAwayPages } from './pages/TakeAwayPages';
import { PengeluaranPages } from './pages/PengeluaranPages';
import { LabaRugiPages } from './pages/LabaRugiPages';
import { RilisAplikasiPages } from './pages/RilisAplikasiPages';
import { MasukanPages, RatingAplikasiPages } from './pages/MasukanRatingPages';
import { DownloadAplikasiPages } from './pages/DownloadAplikasiPages';
import { NonCashMethodPages } from './pages/NonCashMethodPages';
import NotFoundPage from './componen/NotFoundPage';
import DialogHost from './componen/DialogHost';
/** Hindari double dispatch(Me) saat React Strict Mode mount dua kali (race reject → redirect login). */
let meBootstrapPromise = null;

// Domain utama (juragankuliner.com) hanya landing: alamat /login di sana dialihkan ke app.<domain>/login.
// Halaman "/" di app.<domain> (tujuan semua logout & sesi habis) dialihkan ke landing di domain utama.
function BerandaAtauUtama() {
  const utama = alamatUtama();
  useEffect(() => {
    if (!utama) return undefined;
    let batal = false;
    // jangan memotong permintaan logout yang sedang berjalan (sesi di server harus terhapus dulu)
    tungguLogout().then(() => { if (!batal) window.location.replace(utama); });
    return () => { batal = true; };
  }, [utama]);
  return utama ? null : <LandingPage />;
}

function LoginDiApp() {
  const app = alamatAplikasi();
  useEffect(() => {
    if (app) window.location.replace(`${app}/login`);
  }, [app]);
  return app ? null : <LoginPage />;
}

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    if (meBootstrapPromise) return;
    meBootstrapPromise = dispatch(Me()).finally(() => {
      meBootstrapPromise = null;
    });
  }, [dispatch]);
  return (
    <BrowserRouter>
      <DialogHost />
      <LanggananNotice />
      <CatatAkses />
      <Routes>
          <Route path="/" element={<BerandaAtauUtama />} />
            <Route path="/login" element={<LoginDiApp />} />
          {/* Route Admin & Superadmin only - karyawan/kasir tidak bisa akses */}
          <Route path="/dashboard" element={<PrivateRoute element={<DashboardPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/userlist" element={<PrivateRoute element={<UserListPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/profile" element={<PrivateRoute element={<ProfilePages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/branch" element={<PrivateRoute element={<BranchPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/transaction" element={<PrivateRoute element={<TransactionPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/product" element={<PrivateRoute element={<ProductPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/category" element={<PrivateRoute element={<CategoryPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/laporan" element={<PrivateRoute element={<InvoicePages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/serial-number" element={<PrivateRoute element={<SerialNumberPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/serial-report" element={<PrivateRoute element={<SerialNumberReportPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/wearhouse" element={<PrivateRoute element={<WarehousePages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/stockallbranch" element={<PrivateRoute element={<StockAllBranchPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/mutasi" element={<PrivateRoute element={<MutasiPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/rilis-aplikasi" element={<PrivateRoute element={<RilisAplikasiPages />} allowedRoles={['superadmin']} />} />
          <Route path="/masukan" element={<PrivateRoute element={<MasukanPages />} allowedRoles={['superadmin']} />} />
          <Route path="/rating-aplikasi" element={<PrivateRoute element={<RatingAplikasiPages />} allowedRoles={['superadmin']} />} />
          <Route path="/download-aplikasi" element={<PrivateRoute element={<DownloadAplikasiPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/laba-rugi" element={<PrivateRoute element={<LabaRugiPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/pengeluaran" element={<PrivateRoute element={<PengeluaranPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/komprehensif" element={<PrivateRoute element={<KomprehensifPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/penjualankategori" element={<PrivateRoute element={<PenjualanPerkategoriPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/stockpages" element={<PrivateRoute element={<StockPerCabangPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/createjurnal" element={<PrivateRoute element={<CreateJurnalPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/getjurnal" element={<PrivateRoute element={<GetJurnalPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/detail" element={<PrivateRoute element={<DetailsLayout />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/stockcabang" element={<PrivateRoute element={<StockCabangPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/meja" element={<PrivateRoute element={<TableDataPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/takeaway" element={<PrivateRoute element={<TakeAwayPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/noncashmethod" element={<PrivateRoute element={<NonCashMethodPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/notification" element={<PrivateRoute element={<NotificationLayout />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/konfigurasi" element={<PrivateRoute element={<KonfigurasiPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/reservasi" element={<PrivateRoute element={<ReservasiPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/reservasi-kasir" element={<PrivateRoute element={<ReservasiKasir />} allowedRoles={['kasir']} />} />
          <Route path="/struk" element={<PrivateRoute element={<StrukPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/ulasangoogle" element={<PrivateRoute element={<UlasanGoogleHalamanPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/integrasi" element={<PrivateRoute element={<IntegrasiPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/paket-fitur" element={<PrivateRoute element={<PaketFiturPages />} allowedRoles={['superadmin']} />} />
          <Route path="/homepage-settings" element={<PrivateRoute element={<HomepageSettingsPages />} allowedRoles={['superadmin']} />} />
          <Route path="/customer" element={<PrivateRoute element={<CustomerPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/transaksicustomer" element={<PrivateRoute element={<CustomerTransaksiPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/kategoricustomer" element={<PrivateRoute element={<CustomerCategoriPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/tablelayout" element={<PrivateRoute element={<LayoutTablePages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/presensi" element={<PrivateRoute element={<DashboardPresensiPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/pengaturan-absensi" element={<PrivateRoute element={<PengaturanAbsensiPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/gaji-karyawan" element={<PrivateRoute element={<MengelolaGajiKaryawanPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/gaji-karyawan/create" element={<PrivateRoute element={<CreateGajiKaryawanPages />} allowedRoles={['admin', 'superadmin']} />} />
          {/* Route Karyawan / Presensi */}
          <Route path="/dashboardkaryawan" element={<DashboardKaryawanPages />} />
          <Route path="/createAbsen" element={<CreateAbsen />} />
          <Route path="/clockout" element={<ClockOut />} />
          <Route path="/GetAbsen" element={<AbsensiPage />} />
          <Route path="/GetAbsenBulan" element={<Kehadiranbulan />} />
          <Route path="/users" element={<ProfileKaryawan />} />
          <Route path="/editprofilekaryawan" element={<FormEditProfile />} />
          <Route path="/datapresensi" element={<DataPresensiPages />} />
          <Route path="/datapresensibulan" element={<DataPresensiBulanPages />} />
          <Route path="/presensimanual" element={<AbsenManualPages />} />
          <Route path="/lokasipresensi" element={<LokasiPresensiPages />} />
          <Route path="/rekappresensi" element={<RekapPresensiPages />} />
          {/* Gaji - Karyawan */}
          <Route path="/gaji-saya" element={<DataGajiKaryawanPages />} />
          <Route path="/gaji-konfirmasi" element={<ConfirmGajiKaryawanPages />} />
          <Route path="/profilekasir" element={<ProfileKasirPages />} />
          <Route
            path="/transaksikasir"
            element={
              <PrivateRoute
                element={<TransaksiKasirPages />}
                allowedRoles={['kasir']} 
              />
            }
          />
                <Route path="/detail-kasir" element={<PrivateRoute element={<OrderDetails />} allowedRoles={["kasir"]} />} />
          <Route path="/antrian-kasir" element={<PrivateRoute element={<AntrianKasir />} allowedRoles={["kasir"]} />} />
          <Route path="/antrian-dapur" element={<PrivateRoute element={<AntrianKasir modeDapur />} allowedRoles={["dapur"]} />} />
          <Route path="/notification-kasir" element={<PrivateRoute element={<Notification />} allowedRoles={["kasir"]} />} />
          <Route path='/dapur'element={<DapurPages />} />
          <Route path="/layoutmeja" element={<LayoutMejaKasir />} />
           {/* view transaksi kasir */}
           <Route path="/produkpercabang" element={<PrivateRoute element={<ProdukPerCabangPages />} allowedRoles={['kasir']} />} />
          <Route path="/laporan-shift" element={<PrivateRoute element={<LaporanShiftPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/log-aktivitas" element={<PrivateRoute element={<LogAktivitasPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/stok-opname" element={<PrivateRoute element={<StokOpnamePages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/bahan-baku" element={<PrivateRoute element={<BahanBakuPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/pembelian" element={<PrivateRoute element={<PembelianPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/riwayat-refund" element={<PrivateRoute element={<RiwayatRefundPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/cetak-label" element={<PrivateRoute element={<CetakLabelPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/piutang" element={<PrivateRoute element={<PiutangPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/laporan-piutang" element={<PrivateRoute element={<LaporanPiutangPages />} allowedRoles={['admin', 'superadmin']} />} />
          <Route path="/piutang-kasir" element={<PrivateRoute element={<PiutangKasirPages />} allowedRoles={['kasir']} />} />
          <Route path="/retail/piutang" element={<PrivateRoute element={<PiutangRetailPages />} allowedRoles={['kasir']} />} />
          <Route path="/promo" element={<PrivateRoute element={<PromoPages />} allowedRoles={['admin', 'superadmin']} />} />
          {/* view transaksi kasir */}
           {/* view transaksi kasir */}
           {/* <Route path="/produktransaksi" element={<Product />} />  */}
          {/* view transaksi kasir */}
<Route path="/order-status" element={<OrderStatusPage />} />
           <Route path="/status/:orderId" element={<OrderStatusPage />} />
           {/* Retail Routes */}
           <Route path="/retail" element={<PrivateRoute element={<LayoutRetail><TransaksiRetail /></LayoutRetail>} allowedRoles={['kasir']} />} />
           <Route path="/retail/transaksi" element={<PrivateRoute element={<LayoutRetail><CartRetail /></LayoutRetail>} allowedRoles={['kasir']} />} />
           <Route path="/retail/detail" element={<PrivateRoute element={<LayoutRetail><OrderDetailRetail /></LayoutRetail>} allowedRoles={['kasir']} />} />
           <Route path="/retail/profile" element={<PrivateRoute element={<LayoutRetail><ProfileRetail /></LayoutRetail>} allowedRoles={['kasir']} />} />
           <Route path="*" element={<NotFoundPage />} />
       </Routes>
    </BrowserRouter>
  );
}

export default App;